define(["data/config"], function(config) {
    var bindOnce = function(prefix, selector, callback, defaultParameters) {
        var bindingId = "." + prefix + selector;

        $(bindingId).each(function(i, $element) {
            if (!$(this).data(selector + "-attached")) {
                $(this).data(selector + "-attached", true);
                callback(
                    $(this),
                    $($element).getParams(selector, defaultParameters)
                );
            }
        });
    };

    return {
        bindOnce: bindOnce
    };
});
